var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"my-3"},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"primary--text text-h4"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }